// import logo from './logo.svg';
import './App.scss';
import { Container, Carousel, Row, Col, Button } from 'react-bootstrap';
import { useState, useRef } from 'react';
import axios from 'axios';
import product from './product.js';
import productSort from './productSort.js';
import Footer from './component/Footer';
import Header from './component/Header';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Cart from './component/Cart';
import Detail from './routes/Detail';
import Login from './component/Login';



function App() {
  let [product1, setProduct1] = useState(product);
  let [productSort1, setProductSort1] = useState(productSort);
  let [count, setCount] = useState(1);
  let [res, setRes] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ]);



  return (
    <div className="App">

      <Routes>
        <Route path="/" element={
          <>
            {/* 헤더 */}
            <Header></Header>
            {/* 슬라이더 */}
            <Carousel>
              <Carousel.Item interval={3000}>
                <img
                  className="d-block w-100"
                  src={process.env.PUBLIC_URL + "/" + "img/30.jpg"}
                  alt="First slide"
                />
                <Carousel.Caption>
                  <h3>Blossom Canvas Tote Bag</h3>
                  <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item interval={3000}>
                <img
                  className="d-block w-100"
                  src={process.env.PUBLIC_URL + "/" + "img/29.jpg"}
                  alt="Second slide"
                />
                <Carousel.Caption>
                  <h3>Blossom Anorak</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item interval={3000}>
                <img
                  className="d-block w-100"
                  src={process.env.PUBLIC_URL + "/" + "img/20.jpg"}
                  alt="Third slide"
                />
                <Carousel.Caption>
                  <h3>Blossom Nylon Shorts</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                  </p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>

            {/* 상품 목록 구좌 */}
            <Container className='product_wrap'>
              <h4>NEW IN</h4>
              <Row>
                {
                  product1.map((ele, i) => {
                    return (
                      <Product product={product1[i]} i={i} res={res} />
                    )
                  })
                }
              </Row>
            </Container>

            {/* 더보기 버튼 */}
            <div className='more_btn'>
              <Button variant="dark" onClick={() => {
                if (count === 1) {
                  axios.get("https://dhekdo.github.io/react_data/data/product2.json").then((result) => {
                    let copy = [...product1, ...result.data];
                    setProduct1(copy);
                    setCount(2);
                  })
                }
                else if (count === 2) {
                  axios.get("https://dhekdo.github.io/react_data/data/product3.json").then((result) => {
                    let copy = [...product1, ...result.data];
                    setProduct1(copy);
                    setCount(3);
                  })
                }
                else {
                  alert("더이상 상품이 없습니다.");
                }
              }}>
                더 많은 상품 보기 +
              </Button>
            </div>

            {/* view 구좌 */}
            <Container className='view_wrap'>
              <Row>
                <Col lg={6} className="view_left">
                  <img src={process.env.PUBLIC_URL + "/img/view2.jpg"} width="100%" alt='view' />
                  <div className='view_text'>
                    <h1>BLOSSOM COLLECTION</h1>
                    <div>Detail View</div>
                  </div>
                </Col>
                <Col lg={6} className="view_right">
                  <img src={process.env.PUBLIC_URL + "/img/view8.jpg"} width="100%" alt='view' />
                  <span>Blossom Shirket</span>
                  <Row lg={3} className="view_bottom">
                    <Col md={4}>
                      <img src={process.env.PUBLIC_URL + "/img/view4.jpg"} width="100%" alt='view' />
                    </Col>
                    <Col md={4}>
                      <img src={process.env.PUBLIC_URL + "/img/view6.jpg"} width="100%" alt='view' />
                    </Col>
                    <Col md={4}>
                      <img src={process.env.PUBLIC_URL + "/img/view7.jpg"} width="100%" alt='view' />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>

            {/* 영상 구좌 */}
            <div className='video_wrap'>
              <h4>LOOK BOOK</h4>
              
              <iframe width="100%" height="800" src="https://www.youtube.com/embed/D3sRWHNeBcM?autoplay=1&amp;mute=1&playlist=D3sRWHNeBcM&loop=1" title="KANGOL 23SS COLLECTION NEW VIDEO" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>

            {/* best 구좌 */}
            <Container className='product_wrap product_sort_wrap'>
              <div className='sort_btn'>
                <h4>WEEKLY BEST</h4>
                <Button variant="outline-dark" onClick={() => {
                  let copy = [...productSort].sort((a, b) => a.price > b.price ? 1 : -1)
                  setProductSort1(copy);
                  let res1 = [];
                  for (let i in copy) {
                    res1.push(copy[i].id);
                  }
                  setRes(res1);
                }}>낮은가격순</Button>
                <Button variant="outline-dark" onClick={() => {
                  let copy = [...productSort].sort((a, b) => a.price < b.price ? 1 : -1)
                  setProductSort1(copy);
                  let res1 = [];
                  for (let i in copy) {
                    res1.push(copy[i].id);
                  }
                  setRes(res1);
                }}>높은가격순</Button>
              </div>
              <Row>
                {
                  productSort1.map((ele, i) => {
                    return (
                      <ProductSort productSort={productSort1[i]} res={res} setRes={setRes} />
                    )
                  })
                }
              </Row>
            </Container>

            {/* news 구좌 */}
            <div className='news_wrap'>
              <h4>WHAT'S NEWS</h4>
              <Row>
                <Col lg={4}>
                  <img src={process.env.PUBLIC_URL + "/img/news1.jpg"} width="100%" alt='news' />
                  <h5>BLOSSOM COLLECTION</h5>
                </Col>
                <Col lg={4}>
                  <img src={process.env.PUBLIC_URL + "/img/news2.jpg"} width="100%" alt='news' />
                  <h5>23SS NEW BACKPACK</h5>
                </Col>
                <Col lg={4}>
                  <img src={process.env.PUBLIC_URL + "/img/news3.jpg"} width="100%" alt='news' />
                  <h5>23SS NEW ARRIVALS</h5>
                </Col>
              </Row>
            </div>

            {/* 푸터 */}
            <Footer></Footer>
          </>
        } />
        <Route path="/CART" element={<Cart />} />
        <Route path="/DETAIL/:id" element={<Detail product={product1} />} />
        <Route path="/LOGIN" element={<Login />} />
      </Routes>

    </div>
  );
}

function Product(props) {
  let [clickup, setClickup] = useState(0);
  let imgRef = useRef();
  let navigate = useNavigate();
  let imgChange = () => {
    if (clickup === 0) {
      setClickup(1);
      imgRef.current.src = process.env.PUBLIC_URL + "/img/icon_heart_on.png";
    }
    else {
      setClickup(0);
      imgRef.current.src = process.env.PUBLIC_URL + "/img/icon_heart.png";
    }
  }

  return (
    <Col md={3}>
      <img src={process.env.PUBLIC_URL + "/" + props.product.imgUrl} width="100%" alt='의류'
        onClick={() => {
          navigate('/DETAIL/' + props.i)
        }} />
      <h4 className="pt-2">{props.product.title}</h4>
      <div className='product_bottom'>
        <span>{"₩" + props.product.price.toLocaleString()}</span>
        <div className='heart'>
          <img src={process.env.PUBLIC_URL + "/img/icon_heart.png"} alt='herat' ref={imgRef} onClick={() => {
            imgChange();
          }} />
          <span> {clickup}</span>
        </div>
      </div>
    </Col>
  )
}

function ProductSort(props) {
  let [clickup, setClickup] = useState(0);
  let imgRef = useRef();
  let navigate = useNavigate();
  let imgChange = () => {
    if (clickup === 0) {
      setClickup(1);
      imgRef.current.src = process.env.PUBLIC_URL + "/img/icon_heart_on.png";
    }
    else {
      setClickup(0);
      imgRef.current.src = process.env.PUBLIC_URL + "/img/icon_heart.png";
    }
  }

  return (
    <Col md={3}>
      <img src={process.env.PUBLIC_URL + "/" + props.productSort.imgUrl} width="100%" alt='의류'
        onClick={() => {
          navigate('/DETAIL')
        }} />
      <h4 className="pt-2">{props.productSort.title}</h4>
      <div className='product_bottom'>
        <span>{"₩" + props.productSort.price.toLocaleString()}</span>
        <div className='heart'>
          <img src={process.env.PUBLIC_URL + "/img/icon_heart.png"} alt='herat' ref={imgRef} onClick={() => {
            imgChange();
          }} />
          <span> {clickup}</span>
        </div>
      </div>
    </Col>
  )
}

export default App;
